var render = function render(){var _vm=this,_c=_vm._self._c;return _c('van-popup',{attrs:{"close-on-click-overlay":false},model:{value:(_vm.showError),callback:function ($$v) {_vm.showError=$$v},expression:"showError"}},[_c('div',{staticClass:"error"},[_c('div',{staticClass:"user-info"},[_c('div',{staticClass:"user-avatar",style:({
        backgroundImage: 'url(' + _vm.user.headimgurl + ')'
      })}),_c('div',{staticClass:"user-name"},[_vm._v(_vm._s(_vm.user.nickname))])]),_c('div',{staticClass:"content"},[_c('img',{attrs:{"src":require("@/assets/GMError.jpeg")}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }